var Overlay = function (content, options) {
    options = options || {};
    this.content = content;
    this.head = options.head;
    this.timeout = options.timeout;
    this.doneText = options.doneText;
    this.keepFocus = options.keepFocus;
    this.afterAppend = options.afterAppend;
    this.onCancel = options.onCancel;
    this.prompt = options.prompt;
    this.className = options.className;
    
    this.message = options.message;
    
    _.bindAll(this, 'clear');
};
_.extend(Overlay.prototype, Backbone.Events, {
    makeHead: function () {
        var container = $('<div class="overlayHead">');
        container.append(this.head);
        return container;
    },
    makeContent: function () {
        var container = $('<div class="overlay">');
        container.append(this.content);
        return container;
    },
    clear: function () {
        this.trigger('clear');
    },
    cancel: function () {
        this.trigger('cancel');
    },
    hide: function () {
        this.trigger('hide');
    },
    shouldClearPrevious: function (previousOverlay) {
        if (!previousOverlay) {
            // No previous, no need
            return false;
        }
        if (previousOverlay.prompt) {
            // Previous was a prompt, don't clear
            return false;
        }
        // 1: Prompts
        if (this.prompt) {
            if (
                this.message && previousOverlay.message &&
                this.message.type == 'no_such_server' &&
                previousOverlay.message.type == 'whois_response'
            ) {
                // no_such_server doesn't clear whois
                return false;
            } else {
                // all other prompts always clear
                return true;
            }
        }
        if (!previousOverlay.message) {
            // Non-prompt, previous had no message, don't clear
            return false;
        }

        // 2: Non prompts
        if (!this.message) {
            // No message, clear
            return true;
        }
        if (this.message.type != previousOverlay.message.type) {
            // Message of a different type, clear
            return true;
        }
        if (this.message.type == 'whois_response' && this.message.user_nick == previousOverlay.message.user_nick) {
            // Whois nick matches, replace existing whois
            return true;
        }
        if (!_.contains(Overlay.allowMultiple, this.message.type)) {
            // Overlay can't show multiple
            return true;
        }
        return false;
    }
});
Overlay.allowMultiple = [
    'notice',
    'time',
    'watch_status',
    'channel_query',
    'export_finished',
    'whois_response',
    'remote_isupport_params',
    'text',
    'help',
    'stats',
    'list_usage',
    'fail',
    'warn',
    'note'
];
Overlay.alwaysShowHead = [
    'whois_response'
];


module.exports = Overlay;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/overlay.js
// module id = jcM0
// module chunks = 1